import { select } from "redux-saga/effects";
import { RootStateStore } from "src/app/application.reducers";
import { Features } from "src/app/shared/domains/core/pataflag";
// This function can be only calld from Sega Files or Generator Function Body
export function* hasFeature(feature): any {
  const featuresListData: any = yield select((state: RootStateStore) => state.shared.user.features)
  const releasedFeatures = featuresListData.evaluation.featureFlags;
  return releasedFeatures[feature];
}

export const envName = process.env.REACT_APP_ENV.trim();

// export const getTheNewPrUrl = (
//   zone: string,
//   prNo: string,
//   oldUrl: string,
//   hasFeature?: (feature: string) => boolean
// ) => {

//   const env = process.env.REACT_APP_ENV.trim();
//   const zoneUpper = zone?.toUpperCase();

//   console.log("========== PR URL DEBUG START ==========");
//   console.log("ENV:", env);
//   console.log("ZONE:", zone);
//   console.log("ZONE UPPER:", zoneUpper);
//   console.log("PR NUMBER:", prNo);

//   console.log(
//     "RC_180874_S4AMS_RTE_URLS:",
//     hasFeature?.(Features.RC_180874_S4AMS_RTE_URLS)
//   );

//   console.log(
//     "RC_180784_S4EUR_HANA:",
//     hasFeature?.(Features.RC_180784_S4EUR_HANA)
//   );

//   const isRteAms =
//     env === "rte" &&
//     zoneUpper === "R3AA1";

//   const isEurPrd =
//     env === "prod" &&
//     zoneUpper === "R3AE1";

//   console.log("isRteAms:", isRteAms);
//   console.log("isEurPrd:", isEurPrd);
//   console.log("OLD URL:", oldUrl);
//   console.log("========== PR URL DEBUG END ==========");

//   // =====================================================
//   // EUR PROD FEATURE URL
//   // =====================================================

//   if (
//     hasFeature &&
//     hasFeature(Features.RC_180784_S4EUR_HANA) &&
//     isEurPrd
//   ) {

//     const eurUrl =
//       `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad#RGTPP01_ME53N-execute?P_BANFN=${prNo}`;

//     console.log("EUR PROD FEATURE URL:", eurUrl);

//     return eurUrl;
//   }

//   // =====================================================
//   // AMS RTE FEATURE URL
//   // =====================================================

//   if (
//     hasFeature &&
//     hasFeature(Features.RC_180874_S4AMS_RTE_URLS) &&
//     isRteAms
//   ) {

//     const amsUrl =
//       `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/launchpad#RGTPP01_ME53N-execute?P_BANFN=${prNo}`;

//     console.log("AMS FEATURE URL:", amsUrl);

//     return amsUrl;
//   }

//   // =====================================================
//   // OLD EXISTING LOGIC
//   // =====================================================

//   let finalUrl = oldUrl;

//   const newRteEurUrl =
//     `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad#RGTPP01_ME53N-execute?P_BANFN=${prNo}`;

//   const newPpdEurUrl =
//     `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad#RGTPP01_ME53N-execute?P_BANFN=${prNo}`;

//   const newPpdAoaUrl =
//     `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/launchpad#RGTPP01_ME53N-execute?P_BANFN=${prNo}`;

//   const newPpdAoaPsUrl =
//     `https://globe7eurprep.nestle.com:26001/irj/servlet/prt/portal/prtroot/pcd!3a!2f!2fportal_content!2ftemplates!2fiviews!2fsap_transaction_iview?System=R3AO1&TCode=/GLB/RGTPP01_ME53N&GuiType=WinGui&SAP_TransType=TXN&SAP_TechRoleName=CONTROL2007&SAP_Market=XXSAP_DummySystem=&SAP_Source=EXT&SAP_IViewDesc=ME33K&DynamicParameter=P_BANFN%3d${prNo}%26&AutoStart=true&noIEModeReentrant=true`;

//   const newProdAoaUrl =
//     `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoa.nestle.com:55801/launchpad#RGTPP01_ME53N-execute?P_BANFN=${prNo}`;

//   if (env === "rte") {

//     if (zoneUpper === "R3AE1") {

//       finalUrl = newRteEurUrl;

//       console.log("RTE EUR OLD LOGIC URL:", finalUrl);
//     }

//   } else if (env === "test") {

//     if (zoneUpper === "R3AE1") {

//       finalUrl = newPpdEurUrl;

//       console.log("TEST EUR OLD LOGIC URL:", finalUrl);

//     } else if (zoneUpper === "R3AO1") {

//       finalUrl = newPpdAoaUrl;

//       console.log("TEST AOA OLD LOGIC URL:", finalUrl);

//     } else if (zoneUpper === "R3AO1_PS" || !zone) {

//       finalUrl = newPpdAoaPsUrl;

//       console.log("TEST AOA PS OLD LOGIC URL:", finalUrl);
//     }

//   } else if (env === "prod" && zoneUpper === "R3AO1") {

//     finalUrl = newProdAoaUrl;

//     console.log("PROD AOA OLD LOGIC URL:", finalUrl);
//   }

//   console.log("FINAL RETURN URL:", finalUrl);

//   return finalUrl;
// };
export const getTheNewPrUrl = (
  zone: string,
  prNo: string,
  oldUrl: string,
  hasFeature?: (feature: string) => boolean
) => {

  const env = process.env.REACT_APP_ENV.trim();
  const zoneUpper = zone?.toUpperCase();

  console.log("========== PR URL DEBUG START ==========");
  console.log("ENV:", env);
  console.log("ZONE:", zone);
  console.log("ZONE UPPER:", zoneUpper);
  console.log("PR NUMBER:", prNo);

  console.log(
    "RC_180874_S4AMS_RTE_URLS:",
    hasFeature?.(Features.RC_180874_S4AMS_RTE_URLS)
  );

  console.log(
    "RC_180784_S4EUR_HANA:",
    hasFeature?.(Features.RC_180784_S4EUR_HANA)
  );

  const isRteAms =
    env === "rte" &&
    zoneUpper === "R3AA1";

  const isEurPrd =
    env === "prod" &&
    zoneUpper === "R3AE1";

  console.log("isRteAms:", isRteAms);
  console.log("isEurPrd:", isEurPrd);
  console.log("OLD URL:", oldUrl);
  console.log("========== PR URL DEBUG END ==========");

  // =====================================================
  // EUR PROD FEATURE URL
  // =====================================================

  if (
    hasFeature &&
    hasFeature(Features.RC_180784_S4EUR_HANA) &&
    isEurPrd
  ) {

    const eurUrl =
      `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d${prNo}`;

    console.log("EUR PROD FEATURE URL:", eurUrl);

    return eurUrl;
  }

  // =====================================================
  // AMS RTE FEATURE URL
  // =====================================================

  if (
    hasFeature &&
    hasFeature(Features.RC_180874_S4AMS_RTE_URLS) &&
    isRteAms
  ) {

    const amsUrl =
      `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d${prNo}`;

    console.log("AMS FEATURE URL:", amsUrl);

    return amsUrl;
  }

  // =====================================================
  // OLD EXISTING LOGIC
  // =====================================================

  let finalUrl = oldUrl;

  const newRteEurUrl =
    `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d${prNo}`;

  const newPpdEurUrl =
    `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d${prNo}`;

  const newPpdAoaUrl =
    `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d${prNo}`;

  const newPpdAoaPsUrl =
    `https://globe7eurprep.nestle.com:26001/irj/servlet/prt/portal/prtroot/pcd!3a!2f!2fportal_content!2ftemplates!2fiviews!2fsap_transaction_iview?System=R3AO1&TCode=/GLB/RGTPP01_ME53N&GuiType=WinGui&SAP_TransType=TXN&SAP_TechRoleName=CONTROL2007&SAP_Market=XXSAP_DummySystem=&SAP_Source=EXT&SAP_IViewDesc=ME33K&DynamicParameter=P_BANFN%3d${prNo}%26&AutoStart=true&noIEModeReentrant=true`;

  const newProdAoaUrl =
    `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoa.nestle.com:55801/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d${prNo}`;

  if (env === "rte") {

    if (zoneUpper === "R3AE1") {

      finalUrl = newRteEurUrl;

      console.log("RTE EUR OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "test") {

    if (zoneUpper === "R3AE1") {

      finalUrl = newPpdEurUrl;

      console.log("TEST EUR OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AO1") {

      finalUrl = newPpdAoaUrl;

      console.log("TEST AOA OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AO1_PS" || !zone) {

      finalUrl = newPpdAoaPsUrl;

      console.log("TEST AOA PS OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "prod" && zoneUpper === "R3AO1") {

    finalUrl = newProdAoaUrl;

    console.log("PROD AOA OLD LOGIC URL:", finalUrl);
  }

  console.log("FINAL RETURN URL:", finalUrl);

  return finalUrl;
};
export const getTheNewPoUrl = (
  zone: string,
  poNo: string,
  oldUrl: string,
  hasFeature?: (feature: string) => boolean
) => {

  const env = process.env.REACT_APP_ENV.trim();
  const zoneUpper = zone?.toUpperCase();

  console.log("========== PO URL DEBUG START ==========");
  console.log("ENV:", env);
  console.log("ZONE:", zone);
  console.log("ZONE UPPER:", zoneUpper);
  console.log("PO NUMBER:", poNo);

  console.log(
    "RC_180874_S4AMS_RTE_URLS:",
    hasFeature?.(Features.RC_180874_S4AMS_RTE_URLS)
  );

  console.log(
    "RC_180784_S4EUR_HANA:",
    hasFeature?.(Features.RC_180784_S4EUR_HANA)
  );

  const isRteAms =
    env === "rte" &&
    zoneUpper === "R3AA1";

  const isEurPrd =
    env === "prod" &&
    zoneUpper === "R3AE1";

  console.log("isRteAms:", isRteAms);
  console.log("isEurPrd:", isEurPrd);
  console.log("OLD URL:", oldUrl);
  console.log("========== PO URL DEBUG END ==========");

  // =====================================================
  // EUR PROD FEATURE URL
  // =====================================================

  if (
    hasFeature &&
    hasFeature(Features.RC_180784_S4EUR_HANA) &&
    isEurPrd
  ) {

    const eurUrl =
      `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad%23RGTPT01_ME23N-execute%3FP_EBELN%3d${poNo}`;

    console.log("EUR PROD FEATURE URL:", eurUrl);

    return eurUrl;
  }

  // =====================================================
  // AMS RTE FEATURE URL
  // =====================================================

  if (
    hasFeature &&
    hasFeature(Features.RC_180874_S4AMS_RTE_URLS) &&
    isRteAms
  ) {

    const amsUrl =
      `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/launchpad%23RGTPT01_ME23N-execute%3FP_EBELN%3d${poNo}`;

    console.log("View in SAP RTE:", amsUrl);

    return amsUrl;
  }



  // =====================================================
  // OLD EXISTING LOGIC
  // =====================================================

  let finalUrl = oldUrl;

  const newRteEurUrl =
    `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23RGTPT01_ME23N-execute%3FP_EBELN%3d${poNo}`;

  const newPpdEurUrl =
    `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23RGTPT01_ME23N-execute%3FP_EBELN%3d${poNo}`;

  const newPpdAoaUrl =
    `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/launchpad%23RGTPT01_ME23N-execute%3FP_EBELN%3d${poNo}`;

  const newPpdAoaPsUrl =
    `https://globe7eurprep.nestle.com:26001/irj/servlet/prt/portal/prtroot/pcd!3a!2f!2fportal_content!2ftemplates!2fiviews!2fsap_transaction_iview?System=R3AO1&TCode=/GLB/RGTPT01_ME23N&GuiType=WinGui&SAP_TransType=TXN&SAP_TechRoleName=CONTROL2007&SAP_Market=XXSAP_DummySystem=&SAP_Source=EXT&SAP_IViewDesc=ME23N&DynamicParameter=P_EBELN%3d${poNo}%26&AutoStart=true&noIEModeReentrant=true`;

  const newProdAoaUrl =
    `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoa.nestle.com:55801/launchpad%23RGTPT01_ME23N-execute%3FP_EBELN%3d${poNo}`;

  if (env === "rte") {

    if (zoneUpper === "R3AE1") {

      finalUrl = newRteEurUrl;

      console.log("RTE EUR OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "test") {

    if (zoneUpper === "R3AE1") {

      finalUrl = newPpdEurUrl;

      console.log("TEST EUR OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AO1") {

      finalUrl = newPpdAoaUrl;

      console.log("TEST AOA OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AO1_PS" || zone === "") {

      finalUrl = newPpdAoaPsUrl;

      console.log("TEST AOA PS OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "prod" && zoneUpper === "R3AO1") {

    finalUrl = newProdAoaUrl;

    console.log("PROD AOA OLD LOGIC URL:", finalUrl);
  }

  console.log("FINAL RETURN URL:", finalUrl);

  return finalUrl;
}

export const getTheNewViewGrUrl = (
  zone: string,
  matDocNo: string,
  year: string,
  oldUrl: string,
  hasFeature?: (feature: string) => boolean
) => {

  const env = process.env.REACT_APP_ENV.trim();
  const zoneUpper = zone?.toUpperCase();

  console.log("========== VIEW GR URL DEBUG START ==========");
  console.log("ENV:", env);
  console.log("ZONE:", zone);
  console.log("ZONE UPPER:", zoneUpper);
  console.log("MAT DOC NUMBER:", matDocNo);
  console.log("YEAR:", year);

  console.log(
    "RC_180874_S4AMS_RTE_URLS:",
    hasFeature?.(Features.RC_180874_S4AMS_RTE_URLS)
  );

  console.log(
    "RC_180784_S4EUR_HANA:",
    hasFeature?.(Features.RC_180784_S4EUR_HANA)
  );

  const isRteAms =
    env === "rte" &&
    zoneUpper === "R3AA1";

  const isEurPrd =
    env === "prod" &&
    zoneUpper === "R3AE1";

  console.log("isRteAms:", isRteAms);
  console.log("isEurPrd:", isEurPrd);
  console.log("OLD URL:", oldUrl);
  console.log("========== VIEW GR URL DEBUG END ==========");

  // =========================
  // ✅ NEW LOGIC (Feature Toggle)
  // =========================

  if (
    hasFeature &&
    hasFeature(Features.RC_180784_S4EUR_HANA) &&
    isEurPrd
  ) {

    const eurUrl =
      `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad%23Material-postReceipt%3FGODYNPRO-ACTION%3DA04%26GODYNPRO-MAT_DOC%3D${matDocNo}%26GODYNPRO-DOC_YEAR%3D${year}`;

    console.log("EUR PROD FEATURE URL:", eurUrl);

    return eurUrl;
  }

  if (
    hasFeature &&
    hasFeature(Features.RC_180874_S4AMS_RTE_URLS) &&
    isRteAms
  ) {

    const amsUrl =
      `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/launchpad%23Material-postReceipt%3FGODYNPRO-ACTION%3DA04%26GODYNPRO-MAT_DOC%3D${matDocNo}%26GODYNPRO-DOC_YEAR%3D${year}`;

    console.log("AMS FEATURE URL:", amsUrl);

    return amsUrl;
  }

  // =========================
  // 🟢 OLD LOGIC (UNCHANGED)
  // =========================

  let finalUrl = oldUrl;

  // const newRteEurUrl =
  //   `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23RGTFC00_MIR4-execute%3FP_BELNR%3d${matDocNo}%26P_GJAHR%3D${year}`;
  const newRteEurUrl =
    `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23Material-postReceipt%3FGODYNPRO-ACTION%3DA04%26GODYNPRO-MAT_DOC%3D${matDocNo}%26GODYNPRO-DOC_YEAR%3D${year}`;

  const newPpdEurUrl =
    `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23Material-postReceipt%3FGODYNPRO-ACTION%3DA04%26GODYNPRO-MAT_DOC%3D${matDocNo}%26GODYNPRO-DOC_YEAR%3D${year}`;

  const newPpdAoaUrl =
    `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/launchpad%23RGTFC00_MIR4-execute%3FP_BELNR%3d${matDocNo}%26P_GJAHR%3D${year}`;

  const newPpdAoaPsUrl =
    `https://globe7eurprep.nestle.com:26001/irj/servlet/prt/portal/prtroot/pcd!3a!2f!2fportal_content!2ftemplates!2fiviews!2fsap_transaction_iview?System=R3AO1&TCode=MB03&DynamicParameter=RM07M-MBLNR=${matDocNo}&RM07M-MJAHR=${year}&AutoStart=true&noIEModeReentrant=true`;

  const newProdAoaUrl =
    `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoa.nestle.com:55801/launchpad%23Material-postReceipt%3FGODYNPRO-ACTION%3DA04%26GODYNPRO-MAT_DOC%3D${matDocNo}%26GODYNPRO-DOC_YEAR%3D${year}`;

  if (env === "rte") {

    if (zoneUpper === "R3AE1") {

      finalUrl = newRteEurUrl;

      console.log("RTE EUR OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "test") {

    if (zoneUpper === "R3AE1") {

      finalUrl = newPpdEurUrl;

      console.log("TEST EUR OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AO1") {

      finalUrl = newPpdAoaUrl;

      console.log("TEST AOA OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AO1_PS" || !zone) {

      finalUrl = newPpdAoaPsUrl;

      console.log("TEST AOA PS OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "prod" && zoneUpper === "R3AO1") {

    finalUrl = newProdAoaUrl;

    console.log("PROD AOA OLD LOGIC URL:", finalUrl);
  }

  console.log("FINAL RETURN URL:", finalUrl);

  return finalUrl;
};

export const getTheNewInvoiceUrl = (
  compCode: string,
  zone: string,
  InvDocNo: string,
  FiscalYear: string,
  oldUrl: string,
  hasFeature?: (feature: string) => boolean
) => {

  const env = process.env.REACT_APP_ENV.trim();
  const zoneUpper = zone?.toUpperCase();

  console.log("========== INVOICE URL DEBUG START ==========");
  console.log("ENV:", env);
  console.log("ZONE:", zone);
  console.log("ZONE UPPER:", zoneUpper);
  console.log("COMP CODE:", compCode);
  console.log("INVOICE DOC NUMBER:", InvDocNo);
  console.log("FISCAL YEAR:", FiscalYear);

  console.log(
    "RC_180874_S4AMS_RTE_URLS:",
    hasFeature?.(Features.RC_180874_S4AMS_RTE_URLS)
  );

  console.log(
    "RC_180784_S4EUR_HANA:",
    hasFeature?.(Features.RC_180784_S4EUR_HANA)
  );

  const isRteAms =
    env === "rte" &&
    zoneUpper === "R3AA1";

  // const isEurPrd =
  //   env === "prod" &&
  //   zoneUpper === "R3AE1";
  const isEurPrd =
    env === "prod" &&
    (
      zoneUpper === "R3AE1" 
    );

  console.log("isRteAms:", isRteAms);
  console.log("isEurPrd:", isEurPrd);
  console.log("OLD URL:", oldUrl);
  console.log("========== INVOICE URL DEBUG END ==========");

  // =========================
  // ✅ NEW LOGIC (Feature Toggle)
  // =========================

  if (
    hasFeature &&
    hasFeature(Features.RC_180784_S4EUR_HANA) &&
    isEurPrd
  ) {

    const eurUrl =
      `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad%23RGTFC00_MIR4-execute%3FP_BELNR%3d${InvDocNo}%26P_GJAHR%3D${FiscalYear}`;

    console.log("EUR PROD FEATURE URL:", eurUrl);

    return eurUrl;
  }

  if (
    hasFeature &&
    hasFeature(Features.RC_180874_S4AMS_RTE_URLS) &&
    isRteAms
  ) {

    const amsUrl =
      `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/launchpad%23RGTFC00_MIR4-execute%3FP_BELNR%3d${InvDocNo}%26P_GJAHR%3D${FiscalYear}`;

    console.log("AMS FEATURE URL:", amsUrl);

    return amsUrl;
  }

  // =========================
  // 🟢 OLD LOGIC (UNCHANGED)
  // =========================

  let finalUrl = oldUrl;

  const newRteEurUrl =
    `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23RGTFC00_MIR4-execute%3FP_BELNR%3d${InvDocNo}%26P_GJAHR%3D${FiscalYear}`;

  const newPpdEurUrl =
    `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23RGTFC00_MIR4-execute%3FP_BELNR%3d${InvDocNo}%26P_GJAHR%3D${FiscalYear}`;

  const newPpdAoaUrl =
    `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/launchpad%23RGTFC00_MIR4-execute%3FP_BELNR%3d${InvDocNo}%26P_GJAHR%3D${FiscalYear}`;

  const newPpdAoaPsUrl =
    `https://globe7eurprep.nestle.com:26001/irj/servlet/prt/portal/prtroot/pcd!3a!2f!2fportal_content!2ftemplates!2fiviews!2fsap_transaction_iview?System=R3AO1&TCode=MB03&DynamicParameter=RM07M-MBLNR=${InvDocNo}&RM07M-MJAHR=${FiscalYear}&AutoStart=true&noIEModeReentrant=true`;

  const newProdAoaUrl =
    `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoa.nestle.com:55801/launchpad%23RGTFC00_MIR4-execute%3FP_BELNR%3d${InvDocNo}%26P_GJAHR%3D${FiscalYear}`;

  if (env === "rte") {

    if (zoneUpper === "R3AE1") {

      finalUrl = newRteEurUrl;

      console.log("RTE EUR OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "test") {

    if (zoneUpper === "R3AE1") {

      finalUrl = newPpdEurUrl;

      console.log("TEST EUR OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AO1") {

      finalUrl = newPpdAoaUrl;

      console.log("TEST AOA OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AO1_PS" || !zone) {

      finalUrl = newPpdAoaPsUrl;

      console.log("TEST AOA PS OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "prod" && zoneUpper === "R3AO1") {

    finalUrl = newProdAoaUrl;

    console.log("PROD AOA OLD LOGIC URL:", finalUrl);
  }

  console.log("FINAL RETURN URL:", finalUrl);

  return finalUrl;
};
// export const getTheNewPostGrUrl = (
//   zone: string,
//   matDocNo?: string,
//   year?: string,
//   poNo?: string,
//   poItem?: string,
//   oldUrl?: string,
//   hasFeature?: (feature: string) => boolean
// ) => {

//   const env = process.env.REACT_APP_ENV.trim();
//   const zoneUpper = zone?.toUpperCase();

//   console.log("========== POST GR URL DEBUG START ==========");
//   console.log("ENV:", env);
//   console.log("ZONE:", zone);
//   console.log("ZONE UPPER:", zoneUpper);
//   console.log("MAT DOC NO:", matDocNo);
//   console.log("YEAR:", year);
//   console.log("PO NUMBER:", poNo);
//   console.log("PO ITEM:", poItem);

//   console.log(
//     "RC_180874_S4AMS_RTE_URLS:",
//     hasFeature?.(Features.RC_180874_S4AMS_RTE_URLS)
//   );

//   console.log(
//     "RC_180784_S4EUR_HANA:",
//     hasFeature?.(Features.RC_180784_S4EUR_HANA)
//   );

//   const isRteAms =
//     env === "rte" &&
//     zoneUpper === "R3AA1";

//   const isRteEur =
//     env === "rte" &&
//     zoneUpper === "R3AE1";

//   const isEurPrd =
//     env === "prod" &&
//     zoneUpper === "R3AE1";

//   console.log("isRteAms:", isRteAms);
//   console.log("isRteEur:", isRteEur);
//   console.log("isEurPrd:", isEurPrd);
//   console.log("OLD URL:", oldUrl);
//   console.log("========== POST GR URL DEBUG END ==========");

//   // =========================
//   // ✅ EUR PROD FEATURE LOGIC
//   // FIXED FOR PREPOPULATION
//   // =========================

//   if (
//     hasFeature &&
//     hasFeature(Features.RC_180784_S4EUR_HANA) &&
//     isEurPrd
//   ) {

//     const eurUrl =
//       `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad%23Material-postGoodsMovementInWebGUI%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;

//     console.log("EUR PROD FEATURE URL:", eurUrl);

//     return eurUrl;
//   }

//   // =========================
//   // ✅ EUR RTE FEATURE LOGIC
//   // FIXED FOR PREPOPULATION
//   // =========================

//   if (
//     hasFeature &&
//     hasFeature(Features.S2P_178151_ENABLE_S4HANA_RTE_URLS_FOR_E7B) &&
//     isRteEur
//   ) {

//     const rteEurUrl =
//       `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23Material-postGoodsMovementInWebGUI%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;

//     console.log("EUR RTE FEATURE URL:", rteEurUrl);

//     return rteEurUrl;
//   }

//   // =========================
//   // ✅ AMS FEATURE LOGIC
//   // =========================

//   if (
//     hasFeature &&
//     hasFeature(Features.RC_180874_S4AMS_RTE_URLS) &&
//     isRteAms
//   ) {

//     const amsUrl =
//       `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/launchpad%23Material-postGoodsMovementInWebGUI%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;

//     console.log("AMS FEATURE URL:", amsUrl);

//     return amsUrl;
//   }

//   // =========================
//   // 🟢 OLD LOGIC (UNCHANGED)
//   // =========================

//   let finalUrl = oldUrl;

//   const newRteEurUrl =
//     `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23Material-postGoodsMovementInWebGUI%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;

//   const newPpdEurUrl =
//     `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23Material-postGoodsMovementInWebGUI%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;

//   const newPpdAoaUrl =
//     `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/launchpad%23Material-postGoodsMovementInWebGUI%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;

//   const newPpdAoaPsUrl = oldUrl;

//   const newProdAoaUrl =
//     `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoa.nestle.com:55801/launchpad%23Material-postGoodsMovementInWebGUI%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;

//   if (env === "rte") {

//     if (zoneUpper === "R3AE1") {

//       finalUrl = newRteEurUrl;

//       console.log("RTE EUR OLD LOGIC URL:", finalUrl);
//     }

//   } else if (env === "test") {

//     if (zoneUpper === "R3AE1") {

//       finalUrl = newPpdEurUrl;

//       console.log("TEST EUR OLD LOGIC URL:", finalUrl);

//     } else if (zoneUpper === "R3AO1") {

//       finalUrl = newPpdAoaUrl;

//       console.log("TEST AOA OLD LOGIC URL:", finalUrl);

//     } else if (zoneUpper === "R3AO1_PS" || zone === "") {

//       finalUrl = newPpdAoaPsUrl;

//       console.log("TEST AOA PS OLD LOGIC URL:", finalUrl);
//     }

//   } else if (env === "prod" && zoneUpper === "R3AO1") {

//     finalUrl = newProdAoaUrl;

//     console.log("PROD AOA OLD LOGIC URL:", finalUrl);
//   }

//   console.log("FINAL RETURN URL:", finalUrl);

//   return finalUrl;
// };

export const getTheNewPostGrUrl = (
  zone: string,
  matDocNo?: string,
  year?: string,
  poNo?: string,
  poItem?: string,
  oldUrl?: string,
  hasFeature?: (feature: string) => boolean
) => {

  const env = process.env.REACT_APP_ENV.trim();
  const zoneUpper = zone?.toUpperCase();

  console.log("========== POST GR URL DEBUG START ==========");
  console.log("ENV:", env);
  console.log("ZONE:", zone);
  console.log("ZONE UPPER:", zoneUpper);
  console.log("MAT DOC NO:", matDocNo);
  console.log("YEAR:", year);
  console.log("PO NUMBER:", poNo);
  console.log("PO ITEM:", poItem);

  console.log(
    "RC_180874_S4AMS_RTE_URLS:",
    hasFeature?.(Features.RC_180874_S4AMS_RTE_URLS)
  );

  console.log(
    "RC_180784_S4EUR_HANA:",
    hasFeature?.(Features.RC_180784_S4EUR_HANA)
  );

  const isRteAms =
    env === "rte" &&
    zoneUpper === "R3AA1";

  const isEurPrd =
    env === "prod" &&
    zoneUpper === "R3AE1";

  console.log("isRteAms:", isRteAms);
  console.log("isEurPrd:", isEurPrd);
  console.log("OLD URL:", oldUrl);
  console.log("========== POST GR URL DEBUG END ==========");

  // =========================
  // ✅ KEEP THIS ON TOP
  // EUR PROD FEATURE LOGIC
  // =========================

  if (
    hasFeature &&
    hasFeature(Features.RC_180784_S4EUR_HANA) &&
    isEurPrd
  ) {

    // const eurUrl =
    //   `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad%23Material-goodsReceipt%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;
const eurUrl =
  `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad%23Material-postGoodsMovementInWebGUI%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;
  
    console.log("EUR PROD FEATURE URL:", eurUrl);

    return eurUrl;
  }

  // =========================
  // ✅ AMS FEATURE LOGIC
  // =========================

  if (
    hasFeature &&
    hasFeature(Features.RC_180874_S4AMS_RTE_URLS) &&
    isRteAms
  ) {

    const amsUrl =
      `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/launchpad%23Material-goodsReceipt%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;

    console.log("POST GR IN SAP:", amsUrl);

    return amsUrl;
  }

  // =========================
  // 🟢 OLD LOGIC (UNCHANGED)
  // =========================

  let finalUrl = oldUrl;

  // const newRteEurUrl =
  //   `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23Material-goodsReceipt%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;

// const newRteEurUrl =
//   `https://erpeurrte.nestle.com:55821/launchpad#Material-postGoodsMovementInWebGUI?GODYNPRO-PO_NUMBER=${poNo}&GODYNPRO-PO_ITEM=${poItem}&AutoStart=true&GODYNPRO-ACTION=A01&GODYNPRO-REFDOC=R01`;

  const newRteEurUrl =
  `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23Material-postGoodsMovementInWebGUI%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;

  // const newPpdEurUrl =
  //   `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23Material-goodsReceipt%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;

const newPpdEurUrl =  `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23Material-postGoodsMovementInWebGUI%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;


  const newPpdAoaUrl =
    `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/launchpad%23Material-postGoodsMovementInWebGUI%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;

  const newPpdAoaPsUrl = oldUrl;

  const newProdAoaUrl =
    `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoa.nestle.com:55801/launchpad%23Material-postGoodsMovementInWebGUI%3FGODYNPRO-PO_NUMBER%3D${poNo}%26GODYNPRO-PO_ITEM%3D${poItem}%26AutoStart%3Dtrue%26GODYNPRO-ACTION%3DA01%26GODYNPRO-REFDOC%3DR01`;

  if (env === "rte") {

    if (zoneUpper === "R3AE1") {

      finalUrl = newRteEurUrl;

      console.log("RTE EUR OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "test") {

    if (zoneUpper === "R3AE1") {

      finalUrl = newPpdEurUrl;

      console.log("TEST EUR OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AO1") {

      finalUrl = newPpdAoaUrl;

      console.log("TEST AOA OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AO1_PS" || zone === "") {

      finalUrl = newPpdAoaPsUrl;

      console.log("TEST AOA PS OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "prod" && zoneUpper === "R3AO1") {

    finalUrl = newProdAoaUrl;

    console.log("PROD AOA OLD LOGIC URL:", finalUrl);
  }

  console.log("FINAL RETURN URL:", finalUrl);

  return finalUrl;
};

export const getTheNewMyGrAppUrl = (
  zone: string,
  poNo: string,
  oldUrl: string,
  appName: string,
  hasFeature?: (feature: string) => boolean
) => {

  const env = process.env.REACT_APP_ENV.trim();
  const zoneUpper = zone?.toUpperCase();
const isEurPpd = env === "test" && zoneUpper === "R3AE1";
  console.log("========== MY GR APP URL DEBUG START ==========");
  console.log("ENV:", env);
  console.log("ZONE:", zone);
  console.log("ZONE UPPER:", zoneUpper);
  console.log("APP NAME:", appName);
  console.log("PO NUMBER:", poNo);

  console.log(
    "RC_180874_S4AMS_RTE_URLS:",
    hasFeature?.(Features.RC_180874_S4AMS_RTE_URLS)
  );

  console.log(
    "RC_180784_S4EUR_HANA:",
    hasFeature?.(Features.RC_180784_S4EUR_HANA)
  );

  const isRteAms = env === "rte" && zoneUpper === "R3AA1";
  const isEurPrd = env === "prod" && zoneUpper === "R3AE1";

  console.log("isRteAms:", isRteAms);
  console.log("isEurPrd:", isEurPrd);
  console.log("OLD URL:", oldUrl);
  console.log("========== MY GR APP URL DEBUG END ==========");

  const getNavTab = () => {

    if (
      appName === "Post GR in MyGR Exception (Auto)" ||
      appName === "Post GR in myGR (Exception)"
    ) return "Exception";

    if (
      appName === "View GR in myGR app" ||
      appName === "View GR in myGR" ||
      appName === "View GR in myGR app (Auto)"
    ) return "Completed";

    return "Confirm";
  };

  const isViewGrInMyGr = getNavTab() === "Completed";
  const isRteViewGrInMyGr = env === "rte" && isViewGrInMyGr;

  // =====================================================
  // AMS FEATURE URL
  // =====================================================

  if (isRteAms || isRteViewGrInMyGr) {
    const amsNavTab = getNavTab();
//  const amsUrl =
//       `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN&NavTab=${getNavTab()}&purchaseorder=${poNo}`;
    // const amsUrl =
    //   `https://globe7rte.nestle.com:26001//irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN&NavTab=${getNavTab()}&purchaseorder=${poNo}`;
    const amsUrl =
      `https://globe7rte.nestle.com:26001//irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=${amsNavTab}?purchaseorder=${poNo}`;
    console.log("view Gr in My Gr APP:", amsUrl);

    return amsUrl;
  }

  // =====================================================
  // EUR PROD FEATURE URL
  // =====================================================

  if (
    hasFeature &&
    hasFeature(Features.RC_180784_S4EUR_HANA) &&
    isEurPrd
  ) {
const eurUrl =
  `https://globe7.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=${getNavTab()}?purchaseorder=${poNo}`;

  //   const eurUrl =
  // `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad%23MyGrCockpitGr-display%3Fpurchaseorder=${poNo}`;
  //   console.log("EUR PROD FEATURE URL:", eurUrl);

    return eurUrl;
  }

  if (isEurPpd) {

  const eurPpdUrl =
    `https://globe7prep.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=${getNavTab()}?purchaseorder=${poNo}`;

  console.log("EUR PREPROD URL:", eurPpdUrl);

  return eurPpdUrl;
}
  let finalUrl = oldUrl;

  // ---------- RTE ----------
  const newRteAoaUrlConfirm = `https://globe7rte.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https%3A%2F%2Ferpaoarte.nestle.com%3A55802%2Flaunchpad%23MyGrCockpitGr-display?sap-ui-language=EN&NavTab=Confirm&purchaseorder=${poNo}`;

  const newRteAoaUrlException = `https://globe7rte.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https%3A%2F%2Ferpaoarte.nestle.com%3A55802%2Flaunchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=Exception?purchaseorder=${poNo}`;

  const newRteAoaUrlCompleted = `https://globe7rte.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https%3A%2F%2Ferpaoarte.nestle.com%3A55802%2Flaunchpad%23MyGrCockpitGr-display?sap-ui-language=EN&NavTab=Completed&purchaseorder=${poNo}`;

  const newRteEuaUrlConfirm = `https://globe7rte.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=Confirm?purchaseorder=${poNo}`;

  const newRteEuaUrlException = `https://globe7rte.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=Exception?purchaseorder=${poNo}`;

  const newRteEuaUrlCompleted = `https://globe7rte.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=Completed?purchaseorder=${poNo}`;

  // ---------- TEST ----------
  const newPpdAoaUrlConfirm = `https://portal7prepkiosk.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=Confirm?purchaseorder=${poNo}`;

  const newPpdAoaUrlException = `https://portal7prepkiosk.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=Exception?purchaseorder=${poNo}`;

  const newPpdAoaUrlCompleted = `https://portal7prepkiosk.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=Completed?purchaseorder=${poNo}`;

  const newPpdEurUrlConfirm = `https://globe7prep.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=Confirm?purchaseorder=${poNo}`;

  const newPpdEurUrlException = `https://globe7prep.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=Exception?purchaseorder=${poNo}`;

  const newPpdEurUrlCompleted = `https://globe7prep.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=Completed?purchaseorder=${poNo}`;

  // ---------- PROD ----------
  const newProdAoaUrlConfirm = `https://globe7.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoa.nestle.com:55801/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=Confirm?purchaseorder=${poNo}`;

  const newProdAoaUrlException = `https://globe7.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoa.nestle.com:55801/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=Exception?purchaseorder=${poNo}`;

  const newProdAoaUrlCompleted = `https://globe7.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoa.nestle.com:55801/launchpad%23MyGrCockpitGr-display?sap-ui-language=EN?NavTab=Completed?purchaseorder=${poNo}`;

  // ---------- LOGIC ----------
  if (env === "rte") {

    if (zoneUpper === "R3AO1") {

      if (appName.includes("Confirm")) {
        finalUrl = newRteAoaUrlConfirm;
      } else if (appName.includes("Exception")) {
        finalUrl = newRteAoaUrlException;
      } else {
        finalUrl = newRteAoaUrlCompleted;
      }

      console.log("RTE AOA OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AE1") {

      if (appName.includes("Confirm")) {
        finalUrl = newRteEuaUrlConfirm;
      } else if (appName.includes("Exception")) {
        finalUrl = newRteEuaUrlException;
      } else {
        finalUrl = newRteEuaUrlCompleted;
      }

      console.log("RTE EUR OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "test") {

    if (zoneUpper === "R3AE1") {

      if (appName.includes("Confirm")) {
        finalUrl = newPpdEurUrlConfirm;
      } else if (appName.includes("Exception")) {
        finalUrl = newPpdEurUrlException;
      } else {
        finalUrl = newPpdEurUrlCompleted;
      }

      console.log("TEST EUR OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AO1") {

      if (appName.includes("Confirm")) {
        finalUrl = newPpdAoaUrlConfirm;
      } else if (appName.includes("Exception")) {
        finalUrl = newPpdAoaUrlException;
      } else {
        finalUrl = newPpdAoaUrlCompleted;
      }

      console.log("TEST AOA OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "prod") {

    if (zoneUpper === "R3AO1") {

      if (appName.includes("Confirm")) {
        finalUrl = newProdAoaUrlConfirm;
      } else if (appName.includes("Exception")) {
        finalUrl = newProdAoaUrlException;
      } else {
        finalUrl = newProdAoaUrlCompleted;
      }

      console.log("PROD AOA OLD LOGIC URL:", finalUrl);
    }
  }

  console.log("FINAL RETURN URL:", finalUrl);

  return finalUrl;
};

export const getTheNewMyIaAppUrl = (
  zone: string,
  poNo: string,
  oldUrl: string,
  appName: string,
  hasFeature?: (feature: string) => boolean
) => {

  const env = process.env.REACT_APP_ENV.trim();
  const zoneUpper = zone?.toUpperCase();

  console.log("========== MY IA APP URL DEBUG START ==========");
  console.log("ENV:", env);
  console.log("ZONE:", zone);
  console.log("ZONE UPPER:", zoneUpper);
  console.log("APP NAME:", appName);
  console.log("PO NUMBER:", poNo);

  console.log(
    "RC_180874_S4AMS_RTE_URLS:",
    hasFeature?.(Features.RC_180874_S4AMS_RTE_URLS)
  );

  console.log(
    "RC_180784_S4EUR_HANA:",
    hasFeature?.(Features.RC_180784_S4EUR_HANA)
  );

  const isRteAms = env === "rte" && zoneUpper === "R3AA1";
  const isEurPrd = env === "prod" && zoneUpper === "R3AE1";

  console.log("isRteAms:", isRteAms);
  console.log("isEurPrd:", isEurPrd);
  console.log("OLD URL:", oldUrl);
  console.log("========== MY IA APP URL DEBUG END ==========");

  // =========================
  // ✅ NEW LOGIC
  // =========================

  const getNavTab = () => {

    if (appName === "Approve Invoice in IA App (Exception)") {
      return "Exception";
    }

    if (appName === "View Invoice in IA app (Mass)") {
      return "Completed";
    }

    return "Confirm";
  };

  // =====================================================
  // AMS FEATURE URL
  // =====================================================

  if (
    hasFeature &&
    hasFeature(Features.RC_180874_S4AMS_RTE_URLS) &&
    isRteAms
  ) {

    
      // const amsUrl =
      // `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/launchpad%23MyGrCockpitIa-display?sap-ui-language=EN&NavTab=${getNavTab()}&purchaseorder=${poNo}`;

    const amsUrl =
      `https://globe7rte.nestle.com:26001//irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/launchpad%23MyGrCockpitIa-display?sap-ui-language=EN?NavTab=${getNavTab()}?purchaseorder=${poNo}`;

    console.log("AMS FEATURE URL:", amsUrl);

    return amsUrl;
  }

  // =====================================================
  // EUR PROD FEATURE URL
  // =====================================================

  if (
    hasFeature &&
    hasFeature(Features.RC_180784_S4EUR_HANA) &&
    isEurPrd
  ) {

    const eurUrl =
      `https://globe7.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad%23MyGrCockpitIa-display?sap-ui-language=EN&NavTab=${getNavTab()}&purchaseorder=${poNo}`;

    console.log("EUR PROD FEATURE URL:", eurUrl);

    return eurUrl;
  }

  // =========================
  // 🟢 OLD LOGIC (UNCHANGED)
  // =========================

  let finalUrl = oldUrl;

  const newRteEuaUrlConfirm =
    `https://globe7rte.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23MyGrCockpitIa-display?sap-ui-language=EN&NavTab=Confirm&purchaseorder=${poNo}`;

  const newRteEuaUrlException =
    `https://globe7rte.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23MyGrCockpitIa-display?sap-ui-language=EN?NavTab=Exception?purchaseorder=${poNo}`;

  const newRteEuaUrlCompleted =
    `https://globe7rte.nestle.com:26001/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23MyGrCockpitIa-display?sap-ui-language=EN?NavTab=Completed?purchaseorder=${poNo}`;

  const newPpdEuaUrlConfirm =
    `https://globe7prep.nestle.com:26001//irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23MyGrCockpitIa-display?sap-ui-language=EN&NavTab=Confirm&purchaseorder=${poNo}`;

  const newPpdEuaUrlException =
    `https://globe7prep.nestle.com:26001//irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23MyGrCockpitIa-display?sap-ui-language=EN?NavTab=Exception?purchaseorder=${poNo}`;

  const newPpdEuaUrlCompleted =
    `https://globe7prep.nestle.com:26001//irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23MyGrCockpitIa-display?sap-ui-language=EN?NavTab=Completed?purchaseorder=${poNo}`;

  if (env === "rte") {

    if (zoneUpper === "R3AE1") {

      if (appName === "Approve Invoice in IA App (Mass)") {

        finalUrl = newRteEuaUrlConfirm;

      } else if (appName === "Approve Invoice in IA App (Exception)") {

        finalUrl = newRteEuaUrlException;

      } else if (appName === "View Invoice in IA app (Mass)") {

        finalUrl = newRteEuaUrlCompleted;
      }

      console.log("RTE EUR OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "test") {

    if (zoneUpper === "R3AE1") {

      if (appName === "Approve Invoice in IA App (Mass)") {

        finalUrl = newPpdEuaUrlConfirm;

      } else if (appName === "Approve Invoice in IA App (Exception)") {

        finalUrl = newPpdEuaUrlException;

      } else if (appName === "View Invoice in IA app (Mass)") {

        finalUrl = newPpdEuaUrlCompleted;
      }

      console.log("TEST EUR OLD LOGIC URL:", finalUrl);
    }
  }

  console.log("FINAL RETURN URL:", finalUrl);

  return finalUrl;
};

export const getTheNewWorkFlowUrl = (
  WfId: string,
  zone: string,
  oldUrl: string,
  hasFeature?: (feature: string) => boolean
) => {
  const env = process.env.REACT_APP_ENV.trim();
  const zoneUpper = zone?.toUpperCase();

  console.log("========== WORKFLOW URL DEBUG START ==========");
  console.log("ENV:", env);
  console.log("ZONE:", zone);
  console.log("ZONE UPPER:", zoneUpper);
  console.log("WORKFLOW ID:", WfId);

  console.log(
    "RC_180874_S4AMS_RTE_URLS:",
    hasFeature?.(Features.RC_180874_S4AMS_RTE_URLS)
  );

  console.log(
    "RC_180784_S4EUR_HANA:",
    hasFeature?.(Features.RC_180784_S4EUR_HANA)
  );

  const isRteAms =
    env === "rte" &&
    zoneUpper === "R3AA1";

  const isEurPrd =
    env === "prod" &&
    zoneUpper === "R3AE1";

  console.log("isRteAms:", isRteAms);
  console.log("isEurPrd:", isEurPrd);
  console.log("OLD URL:", oldUrl);
  console.log("========== WORKFLOW URL DEBUG END ==========");

  // =========================
  // ✅ EUR PROD FEATURE LOGIC
  // =========================

  if (
    hasFeature &&
    hasFeature(Features.RC_180784_S4EUR_HANA) &&
    isEurPrd
  ) {

    const eurUrl =
      `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/sap/bc/gui/sap/its/webgui?sap-ui-legacy-date-format=1&sap-ui-legacy-number-format=Y&sap-ui-legacy-time-format=0&sap-ui-theme=Nestle_Morning_Horizon&sap-language=EN&~transaction=*SWNWIEX%20P_WI_ID=${WfId};P_APPL=UWL;P_ACTION=EXECUTE;DYNP_OKCODE=ONLI`;

    console.log("EUR PROD FEATURE URL:", eurUrl);

    return eurUrl;
  }

  // =========================
  // ✅ AMS RTE FEATURE LOGIC
  // =========================

  if (
    hasFeature &&
    hasFeature(Features.RC_180874_S4AMS_RTE_URLS) &&
    isRteAms
  ) {

    const amsUrl =
      `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/sap/bc/gui/sap/its/webgui?sap-ui-legacy-date-format=1&sap-ui-legacy-number-format=Y&sap-ui-legacy-time-format=0&sap-ui-theme=Nestle_Morning_Horizon&sap-language=EN&~transaction=*SWNWIEX%20P_WI_ID=${WfId};P_APPL=UWL;P_ACTION=EXECUTE;DYNP_OKCODE=ONLI`;

    console.log("AMS FEATURE URL:", amsUrl);

    return amsUrl;
  }

  // =========================
  // 🟢 OLD LOGIC (UNCHANGED)
  // =========================

  let finalUrl = oldUrl;

  const newRteEurUrl =
    `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/sap/bc/gui/sap/its/webgui?sap-ui-legacy-date-format=1&sap-ui-legacy-number-format=Y&sap-ui-legacy-time-format=0&sap-ui-theme=Nestle_Morning_Horizon&sap-language=EN&~transaction=*SWNWIEX%20P_WI_ID=${WfId};P_APPL=UWL;P_ACTION=EXECUTE;DYNP_OKCODE=ONLI`;

  const newPpdEurUrl =
    `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/sap/bc/gui/sap/its/webgui?sap-ui-legacy-date-format=1&sap-ui-legacy-number-format=Y&sap-ui-legacy-time-format=0&sap-ui-theme=Nestle_Morning_Horizon&sap-language=EN&~transaction=*SWNWIEX%20P_WI_ID=${WfId};P_APPL=UWL;P_ACTION=EXECUTE;DYNP_OKCODE=ONLI`;

  const newPpdAoaUrl =
    `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/sap/bc/gui/sap/its/webgui?sap-ui-legacy-date-format=1&sap-ui-legacy-number-format=Y&sap-ui-legacy-time-format=0&sap-ui-theme=Nestle_Morning_Horizon&sap-language=EN&~transaction=*SWNWIEX%20P_WI_ID=${WfId};P_APPL=UWL;P_ACTION=EXECUTE;DYNP_OKCODE=ONLI`;

  const newPpdAoaPsUrl = oldUrl;

  const newProdAoaUrl =
    `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoa.nestle.com:55801/sap/bc/gui/sap/its/webgui?sap-ui-legacy-date-format=1&sap-ui-legacy-number-format=Y&sap-ui-legacy-time-format=0&sap-ui-theme=Nestle_Morning_Horizon&sap-language=EN&~transaction=*SWNWIEX%20P_WI_ID=${WfId};P_APPL=UWL;P_ACTION=EXECUTE;DYNP_OKCODE=ONLI`;

  if (env === "rte") {
    if (zoneUpper === "R3AE1") {
      finalUrl = newRteEurUrl;
      console.log("RTE EUR OLD LOGIC URL:", finalUrl);
    }
  } else if (env === "test") {
    if (zoneUpper === "R3AE1") {
      finalUrl = newPpdEurUrl;
      console.log("TEST EUR OLD LOGIC URL:", finalUrl);
    } else if (zoneUpper === "R3AO1") {
      finalUrl = newPpdAoaUrl;
      console.log("TEST AOA OLD LOGIC URL:", finalUrl);
    } else if (zoneUpper === "R3AO1_PS" || zone === "") {
      finalUrl = newPpdAoaPsUrl;
      console.log("TEST AOA PS OLD LOGIC URL:", finalUrl);
    }
  } else if (env === "prod" && zoneUpper === "R3AO1") {
    finalUrl = newProdAoaUrl;
    console.log("PROD AOA OLD LOGIC URL:", finalUrl);
  }
  console.log("FINAL RETURN URL:", finalUrl);
  return finalUrl;
};
export const getTheNewContractDisplayUrl = (
  zone: string,
  agNo: string,
  oldUrl: string,
  hasFeature?: (feature: string) => boolean
) => {

  const env = process.env.REACT_APP_ENV.trim();
  const zoneUpper = zone?.toUpperCase();

  console.log("========== CONTRACT DISPLAY URL DEBUG START ==========");
  console.log("ENV:", env);
  console.log("ZONE:", zone);
  console.log("ZONE UPPER:", zoneUpper);
  console.log("AGREEMENT NUMBER:", agNo);

  console.log(
    "RC_180874_S4AMS_RTE_URLS:",
    hasFeature?.(Features.RC_180874_S4AMS_RTE_URLS)
  );

  console.log(
    "RC_180784_S4EUR_HANA:",
    hasFeature?.(Features.RC_180784_S4EUR_HANA)
  );

  const isRteAms = env === "rte" && zoneUpper === "R3AA1";
  const isEurPrd = env === "prod" && zoneUpper === "R3AE1";

  console.log("isRteAms:", isRteAms);
  console.log("isEurPrd:", isEurPrd);
  console.log("OLD URL:", oldUrl);
  console.log("========== CONTRACT DISPLAY URL DEBUG END ==========");

  // =========================
  // ✅ NEW LOGIC (Feature Toggle)
  // =========================

  if (
    hasFeature &&
    hasFeature(Features.RC_180784_S4EUR_HANA) &&
    isEurPrd
  ) {

    const eurUrl =
      `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad%23PurchaseContract-display%3FRM06E-EVRTN%3d${agNo}`;

    console.log("EUR PROD FEATURE URL:", eurUrl);

    return eurUrl;
  }

  if (
    hasFeature &&
    hasFeature(Features.RC_180874_S4AMS_RTE_URLS) &&
    isRteAms
  ) {

    const amsUrl =
      `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/launchpad%23PurchaseContract-display%3FRM06E-EVRTN%3d${agNo}`;

    console.log("AMS FEATURE URL:", amsUrl);

    return amsUrl;
  }

  // =========================
  // 🟢 OLD LOGIC (UNCHANGED)
  // =========================

  let finalUrl = oldUrl;

  const newRteEurUrl =
    `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23PurchaseContract-display%3FRM06E-EVRTN%3d${agNo}`;

  const newPpdEurUrl =
    `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23PurchaseContract-display%3FRM06E-EVRTN%3d${agNo}`;

  const newPpdAoaUrl =
    `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/launchpad%23PurchaseContract-display%3FRM06E-EVRTN%3d${agNo}`;

  const newPpdAoaPsUrl = oldUrl;

  const newProdAoaUrl =
    `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoa.nestle.com:55801/launchpad%23PurchaseContract-display%3FRM06E-EVRTN%3d${agNo}`;

  if (env === "rte") {

    if (zoneUpper === "R3AE1") {

      finalUrl = newRteEurUrl;

      console.log("RTE EUR OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "test") {

    if (zoneUpper === "R3AE1") {

      finalUrl = newPpdEurUrl;

      console.log("TEST EUR OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AO1") {

      finalUrl = newPpdAoaUrl;

      console.log("TEST AOA OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AO1_PS" || zone === "") {

      finalUrl = newPpdAoaPsUrl;

      console.log("TEST AOA PS OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "prod" && zoneUpper === "R3AO1") {

    finalUrl = newProdAoaUrl;

    console.log("PROD AOA OLD LOGIC URL:", finalUrl);
  }

  console.log("FINAL RETURN URL:", finalUrl);

  return finalUrl;
};

export const getTheNewContractChangeUrl = (
  zone: string,
  agNo: string,
  oldUrl: string,
  hasFeature?: (feature: string) => boolean
) => {

  const env = process.env.REACT_APP_ENV.trim();
  const zoneUpper = zone?.toUpperCase();

  console.log("========== CONTRACT CHANGE URL DEBUG START ==========");
  console.log("ENV:", env);
  console.log("ZONE:", zone);
  console.log("ZONE UPPER:", zoneUpper);
  console.log("AGREEMENT NUMBER:", agNo);

  console.log(
    "RC_180874_S4AMS_RTE_URLS:",
    hasFeature?.(Features.RC_180874_S4AMS_RTE_URLS)
  );

  console.log(
    "RC_180784_S4EUR_HANA:",
    hasFeature?.(Features.RC_180784_S4EUR_HANA)
  );

  const isRteAms = env === "rte" && zoneUpper === "R3AA1";
  const isEurPrd = env === "prod" && zoneUpper === "R3AE1";

  console.log("isRteAms:", isRteAms);
  console.log("isEurPrd:", isEurPrd);
  console.log("OLD URL:", oldUrl);
  console.log("========== CONTRACT CHANGE URL DEBUG END ==========");

  // =========================
  // ✅ NEW LOGIC (Feature Toggle)
  // =========================

  if (
    hasFeature &&
    hasFeature(Features.RC_180874_S4AMS_RTE_URLS) &&
    isRteAms
  ) {

    const amsUrl =
      `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/launchpad%23PurchaseContract-changeGUI%3FRM06E-EVRTN%3d${agNo}`;

    console.log("AMS FEATURE URL:", amsUrl);

    return amsUrl;
  }

  if (
    hasFeature &&
    hasFeature(Features.RC_180784_S4EUR_HANA) &&
    isEurPrd
  ) {

    const eurUrl =
      `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad%23PurchaseContract-changeGUI%3FRM06E-EVRTN%3d${agNo}`;

    console.log("EUR PROD FEATURE URL:", eurUrl);

    return eurUrl;
  }

  // =========================
  // 🟢 OLD LOGIC (UNCHANGED)
  // =========================

  let finalUrl = oldUrl;

  const newRteEurUrl =
    `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurrte.nestle.com:55821/launchpad%23PurchaseContract-changeGUI%3FRM06E-EVRTN%3d${agNo}`;

  const newPpdEurUrl =
    `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23PurchaseContract-changeGUI%3FRM06E-EVRTN%3d${agNo}`;

  const newPpdAoaUrl =
    `https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/launchpad%23PurchaseContract-changeGUI%3FRM06E-EVRTN%3d${agNo}`;

  const newPpdAoaPsUrl = oldUrl;

  const newProdAoaUrl =
    `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoa.nestle.com:55801/launchpad%23PurchaseContract-changeGUI%3FRM06E-EVRTN%3d${agNo}`;

  if (env === "rte") {

    if (zoneUpper === "R3AE1") {

      finalUrl = newRteEurUrl;

      console.log("RTE EUR OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "test") {

    if (zoneUpper === "R3AE1") {

      finalUrl = newPpdEurUrl;

      console.log("TEST EUR OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AO1") {

      finalUrl = newPpdAoaUrl;

      console.log("TEST AOA OLD LOGIC URL:", finalUrl);

    } else if (zoneUpper === "R3AO1_PS" || zone === "") {

      finalUrl = newPpdAoaPsUrl;

      console.log("TEST AOA PS OLD LOGIC URL:", finalUrl);
    }

  } else if (env === "prod" && zoneUpper === "R3AO1") {

    finalUrl = newProdAoaUrl;

    console.log("PROD AOA OLD LOGIC URL:", finalUrl);
  }

  console.log("FINAL RETURN URL:", finalUrl);

  return finalUrl;
};
export const getTheNewScivUrl = (
  zone: string,
  scivId: string,
  cmCode: string,
  oldUrl: string,
  hasFeature?: (feature: string) => boolean
) => {

  const env = process.env.REACT_APP_ENV.trim();
  const zoneUpper = zone?.toUpperCase();

  console.log("========== SCIV URL DEBUG START ==========");
  console.log("ENV:", env);
  console.log("ZONE:", zone);
  console.log("ZONE UPPER:", zoneUpper);
  console.log("SCIV ID:", scivId);
  console.log("CM CODE:", cmCode);

  console.log(
    "RC_180874_S4AMS_RTE_URLS:",
    hasFeature?.(Features.RC_180874_S4AMS_RTE_URLS)
  );

  console.log(
    "RC_180784_S4EUR_HANA:",
    hasFeature?.(Features.RC_180784_S4EUR_HANA)
  );

  const isRteAms =
    env === "rte" &&
    zoneUpper === "R3AA1";

  const isEurPrd =
    env === "prod" &&
    zoneUpper === "R3AE1";

  console.log("isRteAms:", isRteAms);
  console.log("isEurPrd:", isEurPrd);
  console.log("OLD URL:", oldUrl);
  console.log("========== SCIV URL DEBUG END ==========");

  if (
    hasFeature &&
    hasFeature(Features.RC_180784_S4EUR_HANA) &&
    isEurPrd
  ) {

    const eurUrl =
      `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad%23RGTFC00_SCIV-execute%3FS_SCIVID-LOW%3D${scivId}%26S_CMCODE-LOW%3D${cmCode}`;

    console.log("EUR PROD FEATURE URL:", eurUrl);

    return eurUrl;
  }

  // =========================
  // ✅ AMS FEATURE LOGIC
  // =========================

  if (
    hasFeature &&
    hasFeature(Features.RC_180874_S4AMS_RTE_URLS) &&
    isRteAms
  ) {

    const amsUrl =
      `https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpamsrte.nestle.com:55831/launchpad%23RGTFC00_SCIV-execute%3FS_SCIVID-LOW%3D${scivId}%26S_CMCODE-LOW%3D${cmCode}`;

    console.log("AMS FEATURE URL:", amsUrl);

    return amsUrl;
  }

  // =========================
  // ✅ EUR PROD FEATURE LOGIC
  // =========================

  if (
    hasFeature &&
    hasFeature(Features.RC_180784_S4EUR_HANA) &&
    isEurPrd
  ) {

    const eurUrl =
      `https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad%23RGTFC00_SCIV-execute%3FS_SCIVID-LOW%3D${scivId}%26S_CMCODE-LOW%3D${cmCode}`;

    console.log("EUR PROD FEATURE URL:", eurUrl);

    return eurUrl;
  }

  // =========================
  // 🟢 FALLBACK OLD URL
  // =========================

  console.log("NO FEATURE MATCHED - RETURNING OLD URL");
  console.log("FINAL RETURN URL:", oldUrl);

  return oldUrl;
};



